module.exports = __webpack_public_path__ + "static/media/midnight-lines-left.d207dee4.png";